import {path} from 'ramda'
import {CollectionFactory} from '@modifi/redux'
import {getAuthenticatedAresClient} from '@modifi/trade-api-clients'

import {REDUCER_KEY, ACTION_KEY} from './constants'

const {actions, selectors, reducer} = CollectionFactory({
  entityPrimaryKeySelector: path(['externalInvoiceId']),
  reducerPath: [REDUCER_KEY],
  actionNamePrefix: [ACTION_KEY],
  fetchRequest: (state, requestParams) => {
    const client = getAuthenticatedAresClient()
    const {productType} = requestParams
    return client.Invoices.all({
      'filter.productTypes': [productType],
    }).then(res => res.data().invoiceInfos)
  },
})

export default reducer

export const selectInvoicesAreLoading = state => productType => {
  if (!productType) return false
  return selectors.selectIsKeyWindowLoading(state, {productType})
}

export const selectInvoicesByProductType = state => productType => {
  if (!productType) return []
  return selectors.selectByKeyWindow(state, {productType})
}

export const aFetchInvoices = productType => dispatch => {
  if (!productType) return null
  return dispatch(actions.fetch({productType}))
}
